import { Dialog, DialogProps } from "../../core/components/dialog.js";
import { DropDownList } from "../../core/components/dropDownList.js";
import { FieldInstance } from "../../core/components/field.js";
import { Config } from "../../core/config/config.js";
import { ComponentHelper } from "../../core/util/componentHelper.js";
import { Helper } from "../../core/util/helper.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import React from "react";
import ReactDOM from "react-dom";

export const OpenStatusSendDialog = () => {
    return new Promise<number>((resolve, reject) => {
        const targetElement = $("<div>");
        const props: any = {
            onOk: (newStatusSend: number) => {
                resolve(newStatusSend)
            },
            onCancel: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
                reject();
            }
        }
        $("body").append(targetElement);
        ReactDOM.render(<StatusSendDialog {...props} />, targetElement[0]);
    })
}

interface StatusSendDialogProps {
    onOk: (newStatusSend: number) => void;
    onCancel: () => void;
}
class StatusSendDialog extends React.Component<StatusSendDialogProps, {
    selectedId: number;
}>{
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Helper.getTranslation("Field.Einsatz.ChangeTransmissionState"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this.isValid()) {
                        this.props.onOk(this.state.selectedId);
                    }
                    else {
                        NotificationHelper.showErrorMessage(Helper.getTranslation("Standard.PflichtfeldAllgemein"));
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    private isValid = (): boolean => {
        return true;
    }

    constructor(props: StatusSendDialogProps) {
        super(props);
        this.state = {
            selectedId: 0
        }
    }

    private createDropDownList = () => {
        let url = "ResourcePlanningLookup/GetStatussend?restrictSendState=" + Config.user.restrictSendState;
        let props = this._factory.getDefaultDropDownProps();
        props.value = this.state.selectedId ?? "";
        props.field.dataSourceUrl = url;
        props.field.dataTextField = "Description";
        props.field.dataValueField = "Id";
        //todo: check IconColor
        props.field.template = "<div style='display: flex'><span style='flex:1;color:{data.IconColor};'># if(data.HasIcon) { # &\\#x${data.IconCode} # } #</span><span style='flex: 3'>${data.Description}</span></div>";
        props.field.valueTemplate = "# if(data.HasIcon) { # <span style='margin-right: 10px; color:{data.IconColor};'>&\\#x${data.IconCode}</span> # } #<span>${data.Description}</span>";
        props.field.optionLabel = "";
        props.field.required = true;
        props.onChange = (_, value: any) => {
            this.setState({ selectedId: value });
        }
        return (
            <FieldInstance label={Helper.getTranslation("Field.Einsatz.statussend")} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    render() {
        return (<>
            <Dialog {...this._dialogProps} open={true}>
                {this.createDropDownList()}
            </Dialog>
        </>)
    }
}